import { useEffect } from "react";
import { useLocation } from "react-router-dom";
  
export default function GoToTop() {
  // it scroll up to top the current page if page load
  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    onTop()
  }, [routePath]);
  
  return null;
}